"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PausableTimeout =
/*#__PURE__*/
function () {
  function PausableTimeout(callback, delay) {
    _classCallCheck(this, PausableTimeout);

    _defineProperty(this, "timeoutId", undefined);

    _defineProperty(this, "start", undefined);

    _defineProperty(this, "remaining", undefined);

    _defineProperty(this, "callback", undefined);

    this.remaining = delay;
    this.callback = callback;
    this.resume();
  }

  _createClass(PausableTimeout, [{
    key: "resume",
    value: function resume() {
      this.start = new Date();
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.callback, this.remaining);
    }
  }, {
    key: "pause",
    value: function pause() {
      clearTimeout(this.timeoutId);
      this.remaining -= new Date() - this.start;
    }
  }, {
    key: "clear",
    value: function clear() {
      clearTimeout(this.timeoutId);
    }
  }]);

  return PausableTimeout;
}();

exports.default = PausableTimeout;